import React, { useState } from 'react';
import { SearchSurvey } from './searchSurvey';
import './surveyAdmin.scss'
import {useHistory} from 'react-router-dom';
import {TitleAdmin} from "../components/titleAdmin/titleAdmin";
import {HeadingAdmin} from "../components/headingAdmin/headingAdmin";

export function AdminSurvey() {
    const [refresh, setRefresh] = useState(0);
    const history = useHistory();

    return (
        <section className="dashboard-admin-container">
            <TitleAdmin
                title={'Tu Opinión'}
                subtitle={'Información de encuestas'}
                event={() => history.push("/admin")}
            />
            <HeadingAdmin
                text={'Agregar encuesta'}
                event={() => history.push("/admin/details-survey/0")}
            />
            <SearchSurvey refresh={refresh} />
        </section>
    );
}
